import * as API from '../lib/_squirrel-api-models.generated';

export type IsolationLevel = API.IsolationLevel;
export const IsolationLevel = API.IsolationLevel;
